import { Link } from "react-router-dom";

const FEATURES = [
  { icon: "ri-ruler-2-line", label: "Roll Gap Control" },
  { icon: "ri-pulse-line", label: "Hydraulic Pressure Control" },
  { icon: "ri-arrow-up-down-line", label: "Servo Cylinder Position Control" },
  { icon: "ri-database-2-line", label: "HPU & Manifold System" },
  { icon: "ri-cpu-line", label: "Motion Controller Program" },
  { icon: "ri-radar-line", label: "Sensor Feedback Control" },
  { icon: "ri-tools-line", label: "Installation & Commissioning" },
];

export default function RollPressHighlightSection() {
  return (
    <section className="relative py-20 md:py-28 bg-background-100 overflow-hidden">
      <div className="absolute inset-0 bp-grid-sm opacity-50" />

      <div className="relative max-w-7xl mx-auto px-4 md:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
        {/* Left: image */}
        <div className="lg:col-span-5">
          <div className="relative rounded-2xl overflow-hidden border border-background-200 h-[420px] md:h-[520px] bg-background-200">
            <img
              src="https://storage.readdy-site.link/project_files/d69eff6a-141f-4a4c-87b1-85937ec8d7bf/e08ed9c4-4ba9-4241-969f-e1ba1154bcb3_ChatGPT-Image-2026-6-15--12_57_31.png"
              alt="Roll Press Equipment - MC TECH"
              className="absolute inset-0 w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/60 via-transparent to-transparent" />
            <div className="absolute bottom-5 left-5 right-5 flex items-center justify-between">
              <div className="bg-background-50/95 backdrop-blur rounded-lg px-4 py-3">
                <div className="text-[10px] font-semibold tracking-[0.2em] uppercase text-secondary-600">
                  Closed-loop System
                </div>
                <div className="text-sm font-heading font-bold text-foreground-950">
                  Roll Gap · Position · Pressure
                </div>
              </div>
              <div className="w-12 h-12 rounded-full bg-accent-500 flex items-center justify-center">
                <i className="ri-play-line text-2xl text-background-50 w-6 h-6 flex items-center justify-center" />
              </div>
            </div>
          </div>

          {/* Mini stats below image */}
          <div className="mt-5 grid grid-cols-3 gap-3">
            {[
              { v: "±0.01", l: "mm Gap" },
              { v: "±0.5", l: "% Pressure" },
              { v: "1ms", l: "Cycle" },
            ].map((s) => (
              <div
                key={s.l}
                className="bg-background-50 border border-background-200 rounded-lg p-3 text-center"
              >
                <div className="text-lg font-heading font-extrabold text-primary-700">
                  {s.v}
                </div>
                <div className="text-[10px] font-medium tracking-wide uppercase text-secondary-600">
                  {s.l}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Right: text */}
        <div className="lg:col-span-7">
          <span className="inline-flex items-center gap-2 text-[11px] font-semibold tracking-[0.2em] uppercase text-accent-700 mb-3">
            <span className="w-6 h-px bg-accent-500" />
            Roll Press Solution
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-extrabold text-foreground-950 leading-tight">
            Roll Press 장비의 핵심은
            <br />
            <span className="text-primary-700">정밀한 압력·위치·갭 제어</span>입니다.
          </h2>
          <p className="mt-5 text-sm md:text-base text-foreground-700 leading-relaxed max-w-2xl">
            Roll Press 장비는 소재를 일정한 압력과 간격으로 압연하기 때문에 좌우
            롤 갭, 실린더 위치, 유압 압력, 하중 제어가 매우 중요합니다.
            MC TECH는 서보밸브, 유압실린더, 위치센서, 압력센서, 모션컨트롤러를
            조합하여 안정적인 롤프레스 제어 시스템을 제공합니다.
          </p>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3">
            {FEATURES.map((f, i) => (
              <div
                key={f.label}
                className="flex items-center gap-3 bg-background-50 border border-background-200 rounded-lg px-4 py-3.5"
              >
                <div className="w-10 h-10 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center shrink-0">
                  <i className={`${f.icon} text-lg w-5 h-5 flex items-center justify-center`} />
                </div>
                <div className="min-w-0">
                  <div className="text-[10px] font-semibold tracking-wider text-secondary-600">
                    FEATURE {String(i + 1).padStart(2, "0")}
                  </div>
                  <div className="text-sm font-semibold text-foreground-950 truncate">
                    {f.label}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <Link
              to="/roll-press"
              className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-primary-600 hover:bg-primary-700 text-background-50 font-semibold text-sm whitespace-nowrap cursor-pointer"
            >
              Roll Press 솔루션 자세히 보기
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
            </Link>
            <Link
              to="/engineering"
              className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-background-50 border border-background-300 hover:border-primary-400 text-foreground-900 font-semibold text-sm whitespace-nowrap cursor-pointer"
            >
              엔지니어링 서비스 보기
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}